import React, { Component } from 'react'
import type { ErrorInfo } from 'react'

import Button from '~/components/Common/Button'

import { HiRefresh } from 'react-icons/hi'

interface Props {
  children: React.ReactNode
  resetKey: number
  onReset: () => void
}

interface State {
  hasError: boolean
  error: Error | null
}

export class DashboardErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false,
      error: null
    }
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Dashboard error:', error, errorInfo)
  }

  componentDidUpdate(prevProps: Props): void {
    // If resetKey changes, clear the error state
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({
        hasError: false,
        error: null
      })
    }
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-8 text-th-text">
          <div className="text-xl font-semibold">Dashboard Error</div>
          <div className="mb-4 text-center">An error occurred while rendering the dashboard: {this.state.error?.message || 'Unknown error'}</div>
          <Button onClick={this.props.onReset} variant="primary" className="flex items-center gap-2">
            <HiRefresh className="h-5 w-5" />
            Reset Dashboard
          </Button>
        </div>
      )
    }

    return this.props.children
  }
}
